
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"29.996"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_48611","data-name":"Group 48611","transform":"translate(-418 -167.711)","fill":"#8787e2","fill-rule":"evenodd"}},[_c('path',{attrs:{"id":"Path_38006","data-name":"Path 38006","d":"M12.422 5.869a1.088 1.088 0 011.05.771l1.184 4.034a5.39 5.39 0 003.751 3.651l4.145 1.152a1.055 1.055 0 010 2.044l-4.145 1.152a5.39 5.39 0 00-3.751 3.651l-1.184 4.034a1.1 1.1 0 01-2.1 0l-1.184-4.034a5.39 5.39 0 00-3.751-3.651l-4.145-1.152a1.055 1.055 0 010-2.044l4.145-1.152a5.39 5.39 0 003.751-3.651l1.184-4.034a1.088 1.088 0 011.05-.771z","transform":"translate(416.499 166.211)"}}),_c('path',{attrs:{"id":"Path_38007","data-name":"Path 38007","d":"M25.529 1.5a1.092 1.092 0 011.06.827l.376 1.509a3.829 3.829 0 002.782 2.782l1.509.376a1.092 1.092 0 010 2.12l-1.509.376a3.829 3.829 0 00-2.782 2.782l-.376 1.509a1.092 1.092 0 01-2.12 0l-.376-1.509a3.823 3.823 0 00-2.782-2.782L19.8 9.113a1.092 1.092 0 010-2.12l1.509-.376a3.823 3.823 0 002.782-2.782l.376-1.509a1.092 1.092 0 011.06-.827z","transform":"translate(415.915 166.211)"}}),_c('path',{attrs:{"id":"Path_38008","data-name":"Path 38008","d":"M23.344 21.16a1.092 1.092 0 011.037.747l.574 1.723a2.185 2.185 0 001.381 1.381l1.723.575a1.092 1.092 0 010 2.071l-1.723.575a2.185 2.185 0 00-1.381 1.381l-.575 1.723a1.092 1.092 0 01-2.071 0l-.575-1.723a2.184 2.184 0 00-1.381-1.381l-1.723-.575a1.092 1.092 0 010-2.071l1.723-.575a2.185 2.185 0 001.381-1.381l.575-1.723a1.092 1.092 0 011.035-.747z","transform":"translate(415.915 165.627)"}})])])
          )
        }
      }
    